var _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.95,108.72l-2.2-3.58c-18.52-30.14-52.01-48.31-87.32-46.1-4.54,.28-9.06,.89-13.52,1.83-32.1,6.79-60.03,30.76-71.61,61.46-6.81,18.06-8.71,38.84-21.63,53.17-16.82,18.65-45.37,19.24-70.47,18.46-25.1-.77-53.67-.11-70.41,18.61-10.48,11.73-13.81,28.4-12.97,44.11,2.24,41.58,31.58,78.76,68.89,97.24,37.31,18.48,81.25,20.13,122.09,12.01,57.21-11.39,111.62-42.66,144.32-90.97,32.7-48.3,40.98-114.11,14.81-166.25Z",
    style: {
      fill: "#E6EEF6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.78,104.33h231.95c6.37,0,11.55,5.17,11.55,11.55V458.79c0,6.37-5.17,11.55-11.55,11.55H119.78c-6.37,0-11.55-5.18-11.55-11.55V115.88c0-6.37,5.18-11.55,11.55-11.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.15,
    y: 130.44,
    width: 238.96,
    height: 305.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.54,451.95c0,5.4-4.38,9.79-9.79,9.79s-9.79-4.38-9.79-9.79,4.38-9.79,9.79-9.79,9.79,4.38,9.79,9.79Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.35,
    y: 114.87,
    width: 76.82,
    height: 4.04,
    rx: 1.22,
    ry: 1.22,
    style: {
      fill: "#3B5A76"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.92,
    y: 154.32,
    width: 190.37,
    height: 32.14,
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.09,165.38h1.44v10.1h-1.44v-10.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.25,165.38v10.1h-1.18l-6.06-7.54v7.54h-1.44v-10.1h1.18l6.06,7.54v-7.54h1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,174.33l.53-1.13c.75,.68,2.04,1.17,3.33,1.17,1.75,0,2.5-.68,2.5-1.56,0-2.47-6.12-.91-6.12-4.66,0-1.56,1.21-2.89,3.87-2.89,1.18,0,2.41,.32,3.25,.89l-.48,1.16c-.88-.56-1.88-.82-2.77-.82-1.72,0-2.45,.72-2.45,1.6,0,2.47,6.12,.92,6.12,4.63,0,1.54-1.24,2.87-3.91,2.87-1.54,0-3.06-.52-3.87-1.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16,171.12v-5.75h1.44v5.69c0,2.24,1.02,3.25,2.84,3.25s2.86-1.01,2.86-3.25v-5.69h1.4v5.75c0,2.93-1.6,4.47-4.27,4.47s-4.27-1.54-4.27-4.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.42,175.48l-2.18-3.1c-.2,.01-.42,.03-.63,.03h-2.5v3.07h-1.44v-10.1h3.94c2.63,0,4.21,1.33,4.21,3.52,0,1.56-.81,2.68-2.22,3.19l2.4,3.39h-1.57Zm-.04-6.58c0-1.44-.97-2.27-2.81-2.27h-2.45v4.55h2.45c1.85,0,2.81-.84,2.81-2.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,172.95h-5.37l-1.11,2.53h-1.49l4.58-10.1h1.43l4.59,10.1h-1.52l-1.11-2.53Zm-.5-1.15l-2.18-4.95-2.18,4.95h4.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,165.38v10.1h-1.18l-6.06-7.54v7.54h-1.44v-10.1h1.18l6.06,7.54v-7.54h1.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.62,170.43c0-2.99,2.28-5.17,5.36-5.17,1.56,0,2.92,.53,3.84,1.57l-.94,.91c-.78-.82-1.73-1.2-2.84-1.2-2.28,0-3.97,1.65-3.97,3.88s1.69,3.88,3.97,3.88c1.11,0,2.06-.39,2.84-1.21l.94,.91c-.92,1.04-2.28,1.59-3.85,1.59-3.06,0-5.34-2.18-5.34-5.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.22,174.22v1.26h-7.33v-10.1h7.13v1.26h-5.69v3.1h5.07v1.23h-5.07v3.26h5.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.95,228.79s0-.18-.01-.54c0-.37,0-.91-.02-1.63,0-1.46-.02-3.67-.04-6.68l.07,.07c-23.67,.11-102.09,.19-195.02,.19h0l.26-.26c0,3.03,0,6.05,0,8.86l-.26-.26c54.26,.04,102.98,.08,138.15,.11,17.6,.03,31.8,.06,41.61,.08,4.9,.02,8.71,.03,11.3,.04l2.95,.02c.67,0,1.02,.02,1.02,.02,0,0-.33,.01-.98,.02l-2.91,.02c-2.58,0-6.37,.02-11.24,.04-9.8,.02-23.98,.05-41.55,.08-35.21,.03-84,.07-138.34,.11h-.26v-.26c0-2.8,0-5.82,0-8.86v-.26h.27c92.93,0,171.35,.08,195.02,.19h.07v.07c-.02,3.04-.03,5.25-.04,6.73,0,.72-.01,1.25-.02,1.61,0,.35-.01,.52-.01,.52Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,207.91c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,364.23s0-.18-.01-.54c0-.37,0-.91-.02-1.63,0-1.46-.02-3.67-.04-6.68l.07,.07c-23.67,.11-102.09,.19-195.02,.19h0l.26-.26c0,3.03,0,6.05,0,8.86l-.26-.26c54.26,.04,102.98,.08,138.15,.11,17.6,.03,31.8,.06,41.61,.08,4.9,.02,8.71,.03,11.3,.04l2.95,.02c.67,0,1.02,.02,1.02,.02,0,0-.33,.01-.98,.02-.67,0-1.64,.01-2.91,.02-2.58,0-6.37,.02-11.24,.04-9.8,.02-23.98,.05-41.55,.08-35.21,.03-84,.07-138.34,.11h-.26v-.26c0-2.8,0-5.82,0-8.86v-.26h.27c92.93,0,171.35,.08,195.02,.19h.07v.07c-.02,3.04-.03,5.26-.04,6.73,0,.72-.01,1.25-.02,1.61,0,.35-.01,.52-.01,.52Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,346.46c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,262.64s0-.18-.01-.54c0-.37,0-.91-.02-1.63,0-1.46-.02-3.67-.04-6.68l.07,.07c-23.67,.11-102.09,.19-195.02,.19h0l.26-.26c0,3.03,0,6.05,0,8.86l-.26-.26c54.26,.04,102.98,.08,138.15,.11,17.6,.03,31.8,.06,41.61,.08,4.9,.02,8.71,.03,11.3,.04l2.95,.02c.67,0,1.02,.02,1.02,.02,0,0-.33,.01-.98,.02l-2.91,.02c-2.58,0-6.37,.02-11.24,.04-9.8,.02-23.98,.05-41.55,.08-35.21,.03-84,.07-138.34,.11h-.26v-.26c0-2.8,0-5.82,0-8.86v-.26h.27c92.93,0,171.35,.08,195.02,.19h.07v.07c-.02,3.04-.03,5.25-.04,6.73,0,.72-.01,1.25-.02,1.61,0,.35-.01,.52-.01,.52Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,244.88c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.01,296.5s-.01-.21-.02-.59c0-.41-.01-.97-.03-1.71-.01-1.51-.04-3.71-.06-6.56l.11,.11c-14.41,.09-46.15,.15-82.93,.15h0c.12-.12-.26,.26,.26-.26h0v2.26c0,.75,0,1.5,0,2.24,0,1.48,0,2.94,0,4.35l-.26-.26c23.26,.04,43.95,.08,58.86,.11,7.45,.03,13.45,.06,17.61,.08,2.06,.02,3.67,.03,4.78,.04,.53,0,.95,.01,1.25,.02,.28,0,.44,.02,.44,.02,0,0-.13,.01-.4,.02-.3,0-.7,.01-1.22,.02-1.1,0-2.69,.02-4.72,.04-4.15,.02-10.13,.04-17.55,.08-14.95,.03-35.71,.07-59.04,.11h-.26v-.26c0-1.41,0-2.87,0-4.35,0-.74,0-1.49,0-2.24v-2.25h0c.52-.53,.15-.16,.26-.27h0c36.79,0,68.52,.06,82.93,.15h.11v.11c-.03,2.88-.05,5.1-.06,6.62-.01,.72-.02,1.28-.03,1.68,0,.37-.02,.55-.02,.55Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,278.74c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06s-.32,.04-.96,.06c-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.33,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.03,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.55,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06s-.32,.04-.96,.06c-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.01,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06s-.32,.04-.96,.06c-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.46,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06s-.32,.04-.96,.06c-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06s-.32,.04-.96,.06c-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.02,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,328.69s-.03-.24-.05-.66c-.01-.48-.03-1.08-.05-1.8-.03-1.61-.06-3.78-.11-6.39l.21,.21c-3.82,.02-8.6,.03-13.8,.05-.06,.06,.49-.49,.26-.26h0v1.17c0,.39,0,.77,0,1.16,0,.77,0,1.52,0,2.26,0,1.48-.01,2.91-.02,4.27l-.24-.24c4.01,.02,7.42,.07,9.87,.12,1.17,.03,2.13,.05,2.87,.06,.67,.02,1.05,.04,1.07,.06,.02,.02-.32,.04-.96,.06-.73,.02-1.67,.04-2.82,.06-2.43,.05-5.91,.1-10.03,.12h-.24v-.24c0-1.36-.01-2.79-.02-4.27,0-.74,0-1.49,0-2.26,0-.38,0-.77,0-1.16v-1.15h0v-.02c-.23,.23,.32-.32,.26-.26,5.2,.02,9.99,.04,13.8,.05h.21v.21c-.03,2.75-.07,4.99-.11,6.52-.02,.7-.04,1.28-.05,1.75-.02,.4-.03,.6-.05,.58Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.07,310.93c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.71,296.5s-.01-.21-.02-.59c0-.41-.01-.97-.03-1.71-.01-1.51-.04-3.71-.06-6.56l.11,.11c-14.41,.09-46.15,.15-82.93,.15h0c.12-.12-.26,.26,.26-.26h0v2.26c0,.75,0,1.5,0,2.24,0,1.48,0,2.94,0,4.35l-.26-.26c23.26,.04,43.95,.08,58.86,.11,7.45,.03,13.45,.06,17.61,.08,2.06,.02,3.67,.03,4.78,.04,.53,0,.95,.01,1.25,.02,.28,0,.44,.02,.44,.02,0,0-.13,.01-.4,.02-.3,0-.7,.01-1.22,.02-1.1,0-2.69,.02-4.72,.04-4.15,.02-10.13,.04-17.55,.08-14.95,.03-35.71,.07-59.04,.11h-.26v-.26c0-1.41,0-2.87,0-4.35v-4.49h0c.52-.53,.15-.16,.26-.27h0c36.79,0,68.52,.06,82.93,.15h.11v.11c-.03,2.88-.05,5.1-.06,6.62-.01,.72-.02,1.28-.03,1.68,0,.37-.02,.55-.02,.55Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,278.74c0,.14-8.57,.26-19.14,.26s-19.14-.12-19.14-.26,8.57-.26,19.14-.26,19.14,.12,19.14,.26Z",
    style: {
      fill: "#17324A",
      stroke: "#17324A",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.65,410.33h-74.01c-7,0-12.67-5.67-12.67-12.67h0c0-7,5.67-12.67,12.67-12.67h74.01c7,0,12.67,5.67,12.67,12.67h0c0,7-5.67,12.67-12.67,12.67Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.31,
    y: 164.74,
    width: 2.5,
    height: 11.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.31,
    y: 164.74,
    width: 2.5,
    height: 11.2,
    transform: "translate(3.22 343.9) rotate(-90)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.87,170.37s0-.05-.02-.15l-.03-.44-.02-.33c-.01-.12-.04-.25-.06-.39-.05-.28-.09-.61-.2-.96-.17-.72-.51-1.57-1.04-2.47-.54-.9-1.31-1.83-2.36-2.63-1.05-.79-2.37-1.46-3.9-1.73-1.52-.26-3.23-.21-4.86,.41-.41,.13-.8,.34-1.21,.53-.38,.23-.78,.44-1.13,.73-.38,.26-.7,.58-1.05,.89-.31,.34-.64,.68-.91,1.07-.55,.76-1.03,1.61-1.32,2.55-.3,.93-.46,1.91-.48,2.92,.01,1,.17,1.99,.48,2.92,.29,.93,.77,1.78,1.32,2.55,.27,.39,.59,.73,.91,1.07,.34,.31,.67,.63,1.05,.89,.35,.29,.75,.5,1.13,.73,.4,.19,.79,.4,1.21,.53,1.63,.62,3.34,.67,4.86,.41,1.53-.27,2.85-.94,3.9-1.73,1.05-.79,1.83-1.73,2.36-2.63,.53-.9,.87-1.75,1.04-2.47,.11-.35,.15-.68,.2-.96,.02-.14,.05-.27,.06-.39l.02-.33,.03-.44c0-.1,.01-.15,.02-.15s0,.05,0,.15c0,.11,0,.26-.01,.44v.33c-.02,.12-.04,.25-.06,.39-.04,.28-.08,.61-.18,.97-.16,.73-.49,1.59-1.02,2.51-.53,.91-1.31,1.87-2.37,2.68-1.06,.81-2.4,1.49-3.95,1.78-1.54,.27-3.29,.23-4.95-.4-.42-.13-.82-.34-1.23-.54-.39-.23-.8-.45-1.16-.74-.38-.26-.72-.59-1.07-.91-.32-.35-.65-.69-.93-1.09-.56-.78-1.05-1.65-1.35-2.6-.31-.95-.47-1.95-.49-2.98,.01-1.02,.18-2.03,.49-2.98,.3-.95,.79-1.82,1.35-2.6,.27-.4,.61-.74,.93-1.09,.35-.32,.69-.65,1.07-.91,.36-.29,.77-.51,1.16-.74,.41-.2,.81-.4,1.23-.54,1.66-.63,3.41-.67,4.95-.4,1.55,.28,2.89,.97,3.95,1.78,1.06,.81,1.84,1.77,2.37,2.68,.53,.92,.86,1.78,1.02,2.51,.1,.36,.14,.69,.18,.97,.02,.14,.04,.27,.05,.39v.33c.02,.19,.02,.34,.02,.45,0,.1,0,.15,0,.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M225.77,399.79h-3.4l-.65,1.57h-1.74l3.27-7.33h1.67l3.28,7.33h-1.78l-.65-1.57Zm-.53-1.29l-1.16-2.81-1.16,2.81h2.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,397.69c0-2.21,1.7-3.79,3.98-3.79,1.27,0,2.32,.46,3.01,1.3l-1.09,1c-.49-.56-1.11-.86-1.84-.86-1.37,0-2.34,.96-2.34,2.34s.97,2.34,2.34,2.34c.73,0,1.35-.29,1.84-.87l1.09,1c-.69,.85-1.75,1.31-3.02,1.31-2.27,0-3.97-1.58-3.97-3.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.91,397.69c0-2.21,1.7-3.79,3.98-3.79,1.27,0,2.32,.46,3.01,1.3l-1.09,1c-.49-.56-1.11-.86-1.84-.86-1.37,0-2.34,.96-2.34,2.34s.97,2.34,2.34,2.34c.73,0,1.35-.29,1.84-.87l1.09,1c-.69,.85-1.75,1.31-3.02,1.31-2.27,0-3.97-1.58-3.97-3.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.72,400v1.36h-5.67v-7.33h5.54v1.36h-3.85v1.59h3.4v1.32h-3.4v1.7h3.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,396.69c0,1.63-1.22,2.65-3.18,2.65h-1.48v2.02h-1.7v-7.33h3.17c1.96,0,3.18,1.02,3.18,2.66Zm-1.72,0c0-.81-.52-1.28-1.56-1.28h-1.38v2.54h1.38c1.04,0,1.56-.47,1.56-1.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.94,395.41h-2.34v-1.38h6.39v1.38h-2.34v5.95h-1.7v-5.95Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "203.23 397.84 204.49 396.58 206.92 398.74 211.69 394.15 212.86 395.41 206.74 401.17 203.23 397.84",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.31,469.71c0,.14-97.75,.26-218.3,.26s-218.32-.12-218.32-.26,97.73-.26,218.32-.26,218.3,.12,218.3,.26Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character",
    "data-motion": "breathe",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.28,444.41l-1.03,16.68s16.61,6.64,16.72,9.75l-32.42-.83,.53-26.06,16.19,.46Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.27,459.43c-.63,.16-1.08,.85-.95,1.49,.13,.64,.83,1.1,1.47,.96,.63-.14,1.2-.96,1-1.58-.2-.62-1.05-1.12-1.64-.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.56,470.01l.16-2.62,31.02,1.77s1.43,.66,1.24,1.68l-32.42-.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,460.94c0,.16-.8,.21-1.59,.7-.8,.47-1.22,1.14-1.37,1.08-.15-.03,.11-.97,1.08-1.55,.96-.58,1.92-.37,1.88-.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.15,462.43c.03,.15-.66,.41-1.21,1.06-.57,.64-.73,1.36-.89,1.35-.15,.02-.24-.91,.47-1.71,.7-.81,1.63-.85,1.63-.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.98,466.55c-.14,.03-.34-.77,.08-1.62,.42-.86,1.18-1.18,1.24-1.05,.09,.13-.41,.59-.75,1.29-.36,.7-.42,1.37-.58,1.38Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.6,457.11c-.07,.14-.79-.09-1.69-.06-.9,.02-1.6,.3-1.68,.16-.09-.12,.61-.69,1.66-.72,1.06-.04,1.79,.49,1.7,.61Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "423.08 447.72 422.9 450.69 406.97 450.14 407.03 446.7 423.08 447.72"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,453.74c0,.07-.63,.15-1.62-.05-.5-.1-1.08-.28-1.69-.57-.3-.14-.61-.32-.92-.52-.15-.1-.32-.2-.48-.39-.17-.17-.26-.59-.05-.84,.17-.24,.47-.34,.7-.34,.24,0,.43,.05,.61,.1,.36,.1,.69,.23,1,.37,.61,.3,1.11,.67,1.47,1.02,.73,.72,.98,1.31,.92,1.34-.07,.05-.43-.45-1.18-1.05-.37-.3-.85-.6-1.43-.85-.29-.12-.6-.23-.92-.31-.34-.1-.63-.11-.73,.04-.03,.06-.04,.08,.03,.18,.07,.09,.21,.19,.35,.29,.28,.19,.57,.36,.85,.51,.56,.3,1.09,.5,1.55,.64,.92,.28,1.53,.34,1.53,.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.53,453.97c-.06,.02-.36-.55-.39-1.58-.01-.51,.05-1.12,.27-1.77,.11-.32,.25-.65,.44-.98,.2-.32,.44-.74,1.06-.79,.32,0,.58,.25,.67,.47,.1,.22,.12,.41,.15,.6,.05,.38,.03,.75-.03,1.09-.12,.69-.42,1.25-.74,1.66-.65,.82-1.32,1-1.33,.94-.05-.08,.51-.37,1.01-1.17,.25-.39,.47-.91,.55-1.51,.04-.3,.04-.62,0-.94-.04-.35-.16-.63-.29-.6-.16,0-.44,.25-.58,.52-.17,.29-.31,.58-.42,.87-.22,.58-.32,1.14-.36,1.61-.07,.95,.09,1.55,0,1.57Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M430,342.8l-25.77,8.28c.31,.23,4.78,29.19,4.78,29.19l-3.73,76.87,20.45,.25,9.15-80.64-4.89-33.96Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.04,444.35l-.52,16.7s16.81,6.14,17.01,9.23l-32.43,.16-.26-26.06,16.19-.03Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.48,459.7c-.63,.17-1.06,.88-.91,1.52,.15,.63,.86,1.08,1.49,.91,.63-.16,1.17-1,.95-1.61-.22-.61-1.09-1.09-1.66-.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.1,470.44l.08-2.63,31.06,.83s1.45,.62,1.29,1.64l-32.43,.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.04,460.89c0,.16-.8,.23-1.57,.75-.79,.49-1.19,1.18-1.33,1.12-.15-.03,.09-.98,1.04-1.58,.95-.61,1.9-.43,1.87-.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.45,462.28c.04,.15-.65,.43-1.18,1.1-.55,.66-.69,1.38-.84,1.38-.15,.03-.26-.9,.42-1.72,.67-.83,1.6-.9,1.61-.75Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4,466.34c-.14,.03-.37-.76,.03-1.62,.4-.87,1.14-1.22,1.21-1.09,.09,.13-.39,.6-.71,1.32-.34,.71-.38,1.38-.54,1.39Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,457.07c-.07,.14-.79-.07-1.69,0-.9,.05-1.59,.35-1.67,.22-.09-.11,.58-.7,1.64-.77,1.05-.07,1.8,.43,1.72,.56Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.93 447.66 393.84 450.63 377.9 450.57 377.86 447.13 393.93 447.66"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,453.69c0,.07-.62,.17-1.62,0-.5-.08-1.08-.24-1.7-.51-.31-.14-.62-.3-.93-.49-.15-.1-.33-.19-.49-.38-.18-.16-.28-.58-.08-.84,.17-.25,.46-.36,.69-.37,.24,0,.43,.04,.61,.08,.36,.09,.7,.2,1.01,.34,.62,.28,1.13,.63,1.5,.98,.76,.69,1.02,1.28,.96,1.31-.07,.05-.44-.44-1.21-1.01-.38-.28-.87-.58-1.45-.81-.29-.11-.6-.21-.93-.28-.34-.09-.64-.09-.72,.06-.03,.06-.04,.08,.04,.18,.07,.09,.21,.18,.36,.28,.29,.19,.58,.35,.86,.49,.57,.28,1.11,.47,1.57,.59,.93,.25,1.54,.3,1.54,.38Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.57,453.92c-.06,.02-.37-.54-.44-1.57-.03-.51,.02-1.13,.21-1.78,.1-.33,.23-.66,.41-.99,.19-.32,.42-.75,1.03-.82,.32-.01,.59,.24,.68,.45,.11,.22,.13,.41,.17,.59,.06,.38,.06,.75,0,1.09-.1,.69-.38,1.27-.69,1.68-.63,.84-1.29,1.04-1.3,.98-.05-.08,.5-.39,.98-1.2,.24-.4,.45-.93,.51-1.53,.03-.3,.02-.62-.03-.94-.05-.34-.18-.62-.31-.59-.16,0-.43,.26-.57,.53-.17,.29-.3,.59-.4,.88-.2,.59-.29,1.15-.31,1.62-.04,.95,.13,1.54,.05,1.57Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,346.9c0,5.81,2.3,113.74,2.3,113.74l19.41-1.73,3.96-66.32,2.09-5.78,2.43-35.73-30.2-4.18Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.42,206.95c.26,.35,15.42,24.4,15.42,24.4l17.05-17.84,8.72,12.59s-18.23,25.73-20.91,26.66c-2.67,.93-11.3-.53-11.3-.53l-12.04-15.89,3.05-29.39Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.97,236.91c-.14,0-.32-1.24-.33-2.78,0-1.53,.05-2.77,.19-2.78,.14,0,.32,1.24,.33,2.78,0,1.53-.05,2.77-.19,2.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.87,189.01l-2.62,6.46s-13.45,11.35-14.67,13.1c-1.22,1.75,9.61,58.33,9.61,58.33,0,0-.7,83.13,0,83.13s9.95,2.97,28.99,1.57c19.04-1.4,22.53-3.32,22.53-3.32l-5.94-73.53-9.08-49.43-15.59-20.08-13.23-16.24Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,217.07s-1.99-9.59-1.83-9.89-4.48-11.63-4.48-11.63c0,0-1.56-5.19-1.56-5.17s-21.2-3.59-21.2-3.59l-1.03,3.2,28.26,35.71,2.89,15.33,2.99-4.18-4.06-19.79Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.42,289.25l-4.6-55.32-3.77-21.58c-.51-4.3-3.39-8.64-3.39-8.64l-11.03-6.37s-2.99-3.67-3.15-4.21l5.21,13.31,1.83,10.63,1.14,24.4h0l6.02,32.74,5.87,72.03,12.78-2.49-6.9-54.48Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.1 224.81 410.57 206.66 402.62 197.34 399.47 193.13 404.36 207.18 408.1 224.81",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "395.54 258.68 414.75 231.36 448.18 241.47 422.89 274.18 391.49 263.98 395.54 258.68",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.42,240.21c0,.46-.37,.83-.83,.83s-.83-.37-.83-.83,.37-.83,.83-.83,.83,.37,.83,.83Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.05,236.48c0,.46-.37,.83-.83,.83s-.83-.37-.83-.83,.37-.83,.83-.83,.83,.37,.83,.83Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M409.38,213.79c-.05,.01,.36,1.78,.93,3.95,.57,2.17,1.07,3.91,1.12,3.9,.05-.01-.36-1.78-.93-3.95-.56-2.17-1.07-3.91-1.12-3.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.76,226.05c.14,.82-.01,1.63-.3,2.3-.28,.67-1.01,1.44-1.73,1.59,0,0-1.72,.61-3.05-.65-1.21-1.14-2.16-3.92-1.91-5.77,.17-1.28,.95-2.62,2.19-2.98,1.62-.46,2.96,.45,3.62,1.55",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.57,222.1s-.12-.3-.51-.72c-.2-.21-.46-.44-.82-.64-.36-.2-.81-.36-1.33-.38-.26,0-.53,.01-.81,.08-.28,.06-.56,.17-.82,.33-.52,.33-.95,.86-1.23,1.48-.29,.62-.44,1.35-.41,2.09,.02,.74,.17,1.5,.41,2.24,.38,1.14,.91,2.24,1.78,2.96,.44,.35,.97,.55,1.48,.61,.51,.06,1.01,.01,1.46-.13h-.01c.38-.08,.68-.29,.94-.51,.25-.22,.46-.47,.62-.72,.32-.51,.43-1.02,.5-1.43,.06-.42,.05-.75,.02-.97-.01-.11-.03-.2-.04-.25-.01-.06-.02-.08-.03-.08-.03,0,.09,.47-.05,1.29-.08,.4-.21,.9-.52,1.38-.16,.24-.36,.47-.6,.68-.24,.2-.54,.39-.87,.46h-.01c-.83,.25-1.93,.19-2.76-.47-.82-.67-1.34-1.75-1.71-2.87-.46-1.45-.6-2.99-.02-4.2,.27-.6,.67-1.1,1.16-1.42,.24-.16,.5-.26,.77-.32,.26-.07,.52-.09,.77-.09,.5,.01,.94,.15,1.28,.33,.35,.18,.62,.4,.82,.6,.4,.39,.55,.68,.57,.67Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.65,225.9c.14,.82-.01,1.63-.3,2.3-.28,.67-1.02,1.44-1.73,1.59,0,0-1.72,.61-3.05-.65-1.21-1.14-2.16-3.92-1.91-5.77,.17-1.27,.95-2.62,2.19-2.98,1.62-.46,2.96,.45,3.62,1.55",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.46,221.94s-.12-.3-.51-.72c-.2-.21-.46-.44-.82-.64-.36-.2-.81-.36-1.33-.38-.26,0-.53,.01-.81,.08-.28,.06-.56,.17-.82,.33-.52,.33-.95,.86-1.23,1.48-.29,.62-.44,1.35-.41,2.09,.02,.74,.17,1.5,.41,2.24,.38,1.14,.91,2.24,1.78,2.96,.44,.35,.97,.55,1.48,.61,.51,.06,1.01,.01,1.46-.13h-.01c.38-.08,.68-.29,.94-.51,.25-.22,.46-.47,.62-.72,.32-.51,.43-1.02,.5-1.43,.06-.42,.05-.75,.02-.97-.01-.11-.03-.2-.04-.25-.01-.06-.02-.08-.03-.08-.03,0,.09,.47-.05,1.29-.08,.4-.21,.9-.52,1.38-.16,.24-.36,.47-.6,.68-.24,.2-.54,.39-.87,.46h-.01c-.83,.25-1.93,.19-2.76-.47-.82-.67-1.34-1.75-1.71-2.87-.46-1.45-.6-2.99-.02-4.2,.27-.6,.67-1.1,1.16-1.42,.24-.16,.5-.26,.77-.32,.26-.07,.52-.09,.77-.09,.5,.01,.94,.15,1.28,.33,.35,.18,.62,.4,.82,.6,.4,.39,.55,.68,.57,.67Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.92,221.9c.77-.37,1.75-.03,2.29,.63,.54,.66,.7,1.57,.63,2.42-.03,.43-.12,.87-.33,1.25-.21,.38-.55,.71-.97,.83-.61,.18-1.28-.1-1.77-.51-.79-.66-1.27-1.68-1.27-2.71,0-.69,.3-1.47,.96-1.66",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,222.15s-.05,0-.15,.03c-.09,.03-.23,.11-.37,.24-.28,.27-.53,.81-.52,1.5,0,.68,.24,1.51,.82,2.21,.29,.35,.66,.67,1.12,.88,.45,.21,1.04,.26,1.52-.03,.48-.28,.77-.76,.9-1.23,.14-.48,.16-.96,.14-1.41-.04-.9-.41-1.71-.96-2.15-.54-.44-1.14-.53-1.51-.49-.19,.02-.33,.07-.42,.11-.09,.04-.13,.07-.13,.08,0,.02,.19-.09,.56-.11,.36-.02,.92,.09,1.41,.52,.5,.42,.83,1.18,.86,2.05,.02,.43-.02,.9-.15,1.34-.13,.44-.4,.87-.81,1.12-.41,.25-.93,.21-1.34,.02-.43-.18-.78-.49-1.05-.81-.56-.66-.8-1.45-.82-2.1-.03-.65,.19-1.18,.43-1.44,.25-.27,.47-.31,.46-.33Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.64,228.49s.04-.14,.13-.32c.09-.18,.27-.41,.53-.57,.27-.16,.55-.25,.75-.32,.2-.07,.33-.12,.32-.15,0-.03-.14-.02-.36,.01-.21,.04-.52,.11-.82,.29-.3,.19-.49,.47-.55,.69-.06,.23-.02,.37,0,.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.62,221.96s.09,.12,.3,.21c.21,.09,.52,.16,.87,.14,.35-.03,.65-.15,.84-.27,.19-.12,.28-.23,.27-.25-.03-.05-.48,.28-1.12,.32-.64,.06-1.13-.2-1.16-.15Z",
    style: {
      fill: "#17324A"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.17,235.44c-1.01,.29-2.14-.45-3.12-.08-.73,.28-1.13,1.21-.83,1.94s1.25,1.09,1.96,.77c1.01-.46,1.23-1.9,2.19-2.47",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.95,239.05c.3-.1,.61-.22,.91-.38l-.17-.32c-1.17,.6-2.28,.73-3.29,.4-1.27-.42-2.36-1.55-3.26-3.37l-.03-.07c-.36-.72-5.3-15.46-6.21-18.27-1.42-4.39,2.24-6.23,2.39-6.31,.15-.08,3.46-1.8,6.87,2.39,3.57,4.39,9.81,13.05,10.38,14.12,.07,.13,.16,.29,.27,.48,.79,1.35,2.44,4.15,.99,6.54-1.62,2.67-3.63,2.49-3.72,2.48l-.04,.36c.09,0,2.32,.22,4.07-2.65,1.56-2.58-.16-5.51-.99-6.91-.11-.18-.2-.34-.27-.46-.58-1.08-6.84-9.78-10.42-14.18-3.61-4.43-7.28-2.51-7.32-2.49-.03,.02-4.09,2.05-2.57,6.74,.75,2.31,5.86,17.56,6.23,18.32l.03,.07c.94,1.9,2.1,3.1,3.47,3.55,.83,.28,1.72,.26,2.66-.04Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,219.92c.05,0-.14-.77,.16-1.96,.15-.59,.43-1.26,.89-1.92,.46-.66,1.09-1.29,1.88-1.77,1.6-.96,3.38-1.06,4.56-.85,1.21,.2,1.86,.64,1.88,.6,0,0-.04-.03-.11-.08-.08-.04-.19-.12-.35-.19-.31-.16-.78-.34-1.39-.46-.61-.12-1.36-.17-2.17-.06-.81,.11-1.7,.38-2.51,.87-.82,.49-1.47,1.15-1.93,1.83-.46,.68-.74,1.38-.87,1.99-.14,.61-.15,1.12-.12,1.46,0,.17,.04,.3,.05,.39,.02,.09,.03,.14,.03,.13Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "373.25 195.48 389.83 216.02 404.68 225.34 375.87 189.01 373.25 195.48",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.58,208.58s-3.48,5.48-4.03,11.08c-.22,2.2,5.24,43.32,5.86,45.17,.62,1.85,7.86,6.47,10.02,7.4,2.16,.92,28.52,9.71,39.31,9.56l2.31-20.35-27.75-4.62s-3.24-3.08-4.93-3.7l-2.31-22.66-3.39-18.19s-9.67-5.98-15.09-3.68Z",
    style: {
      fill: "#E6EEF6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,233.21c-.14,.03-1.63-5.98-3.33-13.44-1.7-7.45-2.97-13.52-2.83-13.55,.14-.03,1.63,5.98,3.33,13.44,1.7,7.45,2.97,13.52,2.83,13.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69,228.44s.04,.14,.09,.42c.05,.3,.12,.72,.21,1.26,.18,1.13,.44,2.76,.77,4.86,.65,4.26,1.6,10.42,2.78,18.1l-.11-.14c.95,.38,1.76,1,2.58,1.64,.82,.64,1.62,1.34,2.42,2.09l-.1-.05c7.96,1.31,17.39,2.87,27.76,4.58l.23,.04-.03,.23c-.72,6.36-1.49,13.22-2.3,20.35l-.03,.23h-.23c-5.02-.07-10.12-1.18-15.27-2.38-6.4-1.53-12.56-3.36-18.47-5.25-1.47-.48-2.93-.96-4.37-1.47-1.47-.45-2.82-1.24-4.09-2.01-1.28-.78-2.51-1.6-3.7-2.46-1.17-.89-2.34-1.74-3.28-2.9-.24-.27-.42-.7-.47-1.04-.09-.36-.14-.71-.2-1.06-.11-.7-.22-1.39-.33-2.07-.2-1.37-.41-2.73-.6-4.06-.37-2.67-.73-5.27-1.08-7.77-.68-5.02-1.29-9.7-1.82-13.97-.53-4.27-.99-8.14-1.34-11.55-.08-.85-.17-1.67-.23-2.47-.05-.78-.16-1.58-.01-2.31,.24-1.45,.57-2.76,.94-3.91,.74-2.3,1.55-4,2.15-5.12,.3-.56,.55-.98,.72-1.25,.17-.28,.28-.41,.28-.41,0,0-.08,.15-.23,.43-.16,.28-.39,.71-.67,1.27-.56,1.13-1.35,2.83-2.05,5.13-.35,1.15-.66,2.45-.89,3.89-.13,.72-.02,1.45,.04,2.25,.06,.79,.16,1.61,.25,2.46,.37,3.4,.86,7.26,1.41,11.53,.57,4.27,1.2,8.94,1.88,13.96,.36,2.51,.73,5.1,1.11,7.77,.2,1.33,.41,2.68,.61,4.06,.11,.68,.22,1.37,.34,2.06,.06,.35,.12,.69,.19,1.02,.06,.36,.17,.61,.39,.87,.85,1.06,2.03,1.93,3.18,2.8,1.17,.85,2.4,1.66,3.67,2.43,1.28,.77,2.55,1.51,4,1.96,1.43,.51,2.89,.98,4.36,1.46,5.9,1.88,12.05,3.7,18.43,5.23,5.12,1.2,10.22,2.3,15.14,2.37l-.25,.23c.82-7.13,1.6-13.99,2.33-20.35l.2,.26c-10.36-1.75-19.79-3.33-27.74-4.67h-.06l-.04-.05c-.78-.74-1.58-1.44-2.39-2.08-.8-.63-1.62-1.25-2.48-1.6l-.1-.04v-.1c-1.13-7.69-2.02-13.85-2.64-18.12-.29-2.11-.52-3.74-.68-4.88-.07-.54-.12-.96-.16-1.26-.03-.28-.04-.43-.04-.43Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,222.33c-.07,.03-.53-.93-1.28-2.47-.76-1.53-1.81-3.67-3.46-5.65-1.66-1.98-3.7-3.25-5.29-3.78-1.6-.55-2.69-.48-2.68-.58,0-.03,.26-.08,.75-.08,.49,0,1.2,.07,2.04,.31,1.69,.46,3.86,1.74,5.58,3.8,1.71,2.05,2.72,4.26,3.4,5.84,.67,1.59,1.01,2.6,.94,2.63Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.61,256.89c-.11-.06,1.5-2.02,4.33-3.09,2.82-1.1,5.33-.72,5.29-.6,0,.16-2.41,.03-5.1,1.08-2.71,1.02-4.41,2.73-4.52,2.6Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.76,260.11c-.13-.02,.52-2.33,2.55-4.39,2.01-2.07,4.31-2.77,4.33-2.64,.07,.15-2.05,1.03-3.96,3.01-1.94,1.95-2.78,4.09-2.92,4.02Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.68,225.34s-.42-.2-1.15-.62c-.79-.47-1.83-1.1-3.12-1.87-2.71-1.67-6.42-3.96-10.72-6.62l-.03-.02-.03-.03-4.98-6.15c-4.59-5.68-8.7-10.83-11.54-14.43l-.07-.08,.04-.09c.82-1.94,1.5-3.53,2-4.71,.22-.5,.41-.92,.56-1.26,.13-.29,.21-.43,.23-.42,.02,0-.03,.17-.13,.46-.13,.35-.28,.78-.47,1.3-.46,1.19-1.08,2.8-1.85,4.77l-.03-.18c2.93,3.54,7.09,8.65,11.67,14.33,1.74,2.17,3.42,4.25,4.96,6.17l-.06-.05c4.26,2.72,7.93,5.06,10.62,6.77,1.25,.82,2.27,1.49,3.04,1.99,.7,.47,1.08,.74,1.06,.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.1,229.2s0-.48,.1-1.34c.12-.95,.27-2.17,.46-3.64,.41-3.09,1.02-7.38,1.73-12.2l.03,.16c-.31-.58-.65-1.2-.99-1.83-2.54-4.72-4.81-9.01-6.43-12.13-.77-1.5-1.41-2.74-1.9-3.7-.44-.88-.66-1.37-.63-1.39,.03-.02,.32,.45,.81,1.3,.53,.94,1.22,2.16,2.04,3.62,1.7,3.07,4.03,7.33,6.57,12.05,.34,.63,.67,1.25,.98,1.83l.04,.08v.08c-.74,4.82-1.4,9.11-1.91,12.18-.25,1.46-.46,2.68-.62,3.62-.16,.85-.26,1.31-.29,1.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.69,211.39l.86-.52-.86,.51c-1.34-2.21-2.72-4.5-3.73-6.96l-.18-.43c-1.01-2.45-2.16-5.22-1.68-7.91v-.07c.25-1.15,.89-2.21,1.84-3l.28-.23h.83v1.55l.17,.22c-.06,.05-.12,.11-.18,.16v.07h-.07c-.47,.47-.78,1.04-.89,1.64v.06c-.37,2.09,.65,4.56,1.55,6.74l.18,.43c.95,2.32,2.3,4.54,3.59,6.68l-1.71,1.04Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.26,272.34s.06,.26,.14,.75c.07,.54,.17,1.26,.29,2.16,.25,1.88,.57,4.6,.96,7.96,.77,6.73,1.72,16.04,2.59,26.34,.87,10.3,1.49,19.64,1.87,26.4,.19,3.38,.32,6.12,.39,8.01,.03,.91,.05,1.63,.07,2.18,.01,.5,0,.76-.01,.76-.02,0-.05-.26-.09-.76-.04-.55-.1-1.27-.17-2.17-.14-1.95-.33-4.66-.56-8-.47-6.75-1.15-16.08-2.02-26.38-.87-10.29-1.77-19.6-2.44-26.34-.33-3.33-.6-6.04-.79-7.98-.08-.9-.15-1.63-.2-2.17-.04-.5-.05-.76-.03-.76Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.43,295.8s-.22,.26-.68,.65c-.46,.39-1.13,.94-1.98,1.61-1.69,1.32-4.08,3.12-6.94,4.77-1.43,.82-2.85,1.51-4.17,2.05-1.33,.52-2.56,.93-3.62,1.16-1.05,.25-1.92,.39-2.52,.43-.6,.05-.94,.06-.94,.03-.01-.1,1.31-.24,3.37-.82,1.03-.28,2.23-.71,3.53-1.25,1.29-.56,2.68-1.25,4.1-2.06,2.82-1.63,5.23-3.37,6.98-4.61,1.74-1.25,2.83-2.02,2.88-1.96Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.96,299.7s-.16,.31-.54,.81c-.37,.51-.95,1.2-1.73,2-1.54,1.62-3.95,3.62-6.97,5.23-3.03,1.61-6.03,2.49-8.24,2.87-1.1,.19-2,.3-2.63,.32-.62,.03-.97,.03-.97,0,0-.09,1.37-.2,3.52-.67,2.16-.47,5.09-1.39,8.06-2.96,2.97-1.59,5.37-3.5,6.96-5.03,1.6-1.53,2.45-2.61,2.53-2.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59,311.27c-.14,.01-.38-1.21-.54-2.74-.15-1.53-.16-2.78-.02-2.79,.14-.01,.38,1.21,.54,2.74,.15,1.53,.16,2.78,.02,2.79Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.19,178.74c-.71,.05-1.37-.49-1.73-1.17-.36-.68-.47-1.47-.57-2.24-.47-3.41-.94-6.81-1.41-10.22-.4-2.89-.8-5.79-.71-8.71,.09-2.92,1.25-5.5,2.57-8.02,1.54-2.96,7.78-8.19,18.14-5.26",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.66,166.48c-.14-.06-5.53-1.53-5.26,3.95,.28,5.47,5.71,4.07,5.71,3.91,0-.16-.46-7.86-.46-7.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.34,172.35s-.09,.07-.25,.15c-.15,.08-.42,.14-.71,.05-.59-.18-1.12-1.08-1.2-2.06-.04-.5,.04-.98,.2-1.38,.15-.41,.39-.7,.68-.77,.29-.08,.5,.08,.58,.23,.08,.15,.05,.26,.08,.27,.02,.01,.11-.1,.06-.32-.03-.11-.1-.23-.23-.33-.14-.1-.33-.14-.53-.11-.42,.05-.78,.46-.95,.9-.2,.44-.3,.98-.25,1.54,.09,1.1,.71,2.1,1.51,2.29,.39,.08,.71-.05,.86-.19,.16-.14,.19-.27,.17-.28Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.79,176.66c-.02-3.87-.72-11.83-1.43-19.03-.77-7.74-7.35-13.6-15.13-13.45h-.77c-8.32,.65-12.43,8.08-11.56,16.38l1.17,26.48,19.85,10.89-.07-11.88s7.99-1.39,7.94-9.4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.86,186.06s-5.05,.51-10.5-2.77c0,0,2.52,5.81,10.5,4.94v-2.16Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.71,162.88c.03,.6-.45,1.13-1.08,1.17-.63,.05-1.17-.41-1.2-1.01-.03-.6,.45-1.13,1.08-1.17,.63-.05,1.17,.41,1.2,1.01Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.82,161.16c-.14,.15-1.02-.47-2.25-.45-1.23,0-2.12,.66-2.26,.51-.07-.07,.07-.34,.46-.63,.38-.29,1.04-.58,1.8-.59,.77,0,1.42,.26,1.79,.54,.38,.28,.52,.55,.45,.62Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.74,163.13c.03,.6-.45,1.13-1.08,1.17-.63,.05-1.17-.41-1.2-1.01-.03-.6,.45-1.13,1.08-1.17,.63-.05,1.17,.41,1.2,1.01Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.55,161.04c-.12,.17-1.06-.36-2.28-.2-1.22,.14-2.04,.88-2.19,.75-.07-.06,.03-.34,.39-.68,.35-.33,.97-.69,1.73-.78,.76-.09,1.44,.11,1.84,.34,.41,.24,.57,.49,.51,.57Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.25,171.08c0-.07,.76-.22,1.99-.4,.31-.04,.61-.11,.66-.32,.07-.23-.07-.56-.23-.93-.31-.75-.63-1.55-.97-2.38-1.35-3.38-2.34-6.17-2.2-6.22,.14-.05,1.35,2.65,2.7,6.03,.33,.83,.64,1.63,.93,2.39,.13,.36,.34,.76,.19,1.23-.08,.24-.31,.41-.51,.47-.2,.07-.38,.07-.53,.08-1.25,.09-2.02,.11-2.03,.04Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,172c.2-.02,.23,1.32,1.39,2.25,1.16,.93,2.58,.75,2.59,.94,.02,.08-.31,.27-.91,.29-.59,.03-1.45-.14-2.16-.71-.71-.57-1.02-1.34-1.08-1.89-.06-.56,.08-.89,.17-.89Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.62,155.73c-.12,.34-1.35,.2-2.79,.4-1.44,.17-2.6,.62-2.8,.32-.09-.14,.11-.46,.57-.79,.46-.33,1.2-.65,2.06-.77,.87-.11,1.66,.01,2.19,.22,.53,.2,.81,.46,.76,.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.19,158.03c-.21,.28-1.06,0-2.08,.01-1.02-.03-1.88,.22-2.08-.07-.09-.14,.04-.42,.41-.69,.37-.27,.98-.5,1.69-.49,.7,0,1.31,.25,1.67,.53,.37,.28,.49,.57,.4,.7Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.09,143.33c-2.83-1.11-5.7-.53-8.71-.08-2.39,.35-4.47,1.12-6.41,2.55-3.04,2.25-4.55,5.83-4.71,9.61-.16,3.78,.23,7.13,1.18,10.79l.3-.07c-.18,.92-.36,1.9-.04,2.79s1.35,1.58,2.21,1.21c1.01-.44,1.04-1.83,.95-2.93-.31-3.74-.26-7.37-.04-11.12,.16-2.77,1.73-6.15,3.89-7.47,3.93-2.61,9.04-.48,10.78-.18,2.66-2.28,5.15-.5,6.78,1.48-.6-2.98-3.35-5.47-6.18-6.59Z",
    style: {
      fill: "#17324A"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,148.43c1.75,.02,3.15-1.18,5.11-.86,1.18,.19,2.37,2.12,3.4,4.52,1.17-.71,1.85-2.16,1.63-3.52-.22-1.35-1.31-2.52-2.65-2.83,.49,.26,1.01,.53,1.56,.51,.55-.02,1.13-.45,1.1-1.01-.02-.4-.34-.72-.65-.97-1.75-1.4-4.08-2.07-6.31-1.81-2.23,.26-4.34,1.43-5.73,3.19",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.52,145.12c-.05,.07-.57-.3-1.51-.6-.93-.3-2.34-.46-3.76,.02-1.41,.49-2.42,1.49-2.97,2.31-.56,.82-.74,1.43-.82,1.41-.06,0,0-.67,.51-1.6,.5-.91,1.55-2.06,3.11-2.6,1.56-.54,3.1-.29,4.05,.12,.98,.41,1.43,.9,1.39,.94Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,151.15c-.09-.02,.25-.73,.01-1.86-.12-.55-.39-1.19-.88-1.75-.48-.56-1.21-1-2.04-1.22-1.7-.47-3.3,.14-4.27,.74-.99,.62-1.48,1.18-1.54,1.12-.05-.03,.35-.7,1.34-1.43,.5-.36,1.15-.72,1.94-.93,.79-.22,1.73-.25,2.66,0,.92,.25,1.74,.76,2.27,1.41,.53,.65,.79,1.38,.87,2,.15,1.27-.34,1.96-.38,1.92Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,164.33s-.12-.25-.21-.73c-.09-.48-.18-1.18-.18-2.06-.02-1.74,.37-4.22,1.66-6.6,1.29-2.38,3.14-4.07,4.61-5,.74-.48,1.37-.79,1.82-.98,.45-.19,.71-.26,.73-.23,.04,.08-.96,.5-2.34,1.51-1.38,.99-3.12,2.66-4.36,4.95-1.24,2.29-1.68,4.66-1.75,6.36-.08,1.71,.11,2.77,.02,2.78Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,165.34c-.12,.05-.65-2.76,.45-6.01,1.07-3.26,3.18-5.19,3.25-5.08,.13,.1-1.73,2.11-2.75,5.25-1.06,3.12-.78,5.85-.94,5.85Z",
    style: {
      fill: "#3B5A76"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466.39,211.12c-.23-.61-1.39-.75-1.39-.75l.23-.35c.33-.5,.38-1.13,.12-1.67-.04-.08-.08-.16-.13-.25-.38-.64-1.34-.96-1.34-.96,0,0,.85-1.15,.64-1.73-.28-.76-1.54-1.72-2.62-1.54-1.16,.2-3.69,.97-5.45,1.63-.69,.26-1.45-.16-1.6-.89-.28-1.38-.83-3.51-1.75-5.05-1-1.67-2.17-1.74-2.88-1.58-.34,.07-.53,.44-.4,.76,.38,.92,1.12,2.77,1.27,3.52,.19,.9-.46,7.41-.46,7.41l-3.3,4.45,7.5,10.83,3.3-4.9,7.08-3.12s1.34-1.68,1.19-2.26c-.14-.58-.69-.93-.69-.93l.87-1.23s.06-.79-.18-1.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.51,207.29s-.05,.04-.15,.1c-.12,.07-.26,.15-.43,.25-.4,.22-.95,.52-1.61,.89-.69,.38-1.5,.82-2.4,1.31-.46,.24-.92,.52-1.45,.74-.52,.21-1.19,.31-1.74-.04-.27-.17-.45-.46-.53-.75-.08-.3-.08-.6-.01-.89,.12-.58,.51-1.03,.91-1.36,.41-.33,.83-.58,1.23-.81l1.09-.65c.66-.39,1.19-.7,1.59-.93,.18-.1,.32-.18,.44-.25,.1-.05,.16-.08,.16-.08,0,0-.05,.04-.14,.11-.11,.07-.25,.16-.42,.27-.39,.24-.92,.58-1.56,.98-.33,.21-.7,.43-1.08,.67-.39,.24-.81,.49-1.2,.81-.38,.32-.74,.74-.85,1.28-.12,.51,0,1.15,.48,1.46,.23,.15,.52,.21,.79,.2,.28,0,.55-.08,.8-.18,.51-.21,.98-.49,1.43-.72,.91-.48,1.72-.91,2.42-1.27,.68-.35,1.23-.64,1.64-.85l.45-.22c.1-.05,.16-.07,.16-.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.47,210.54s-.11,.08-.34,.2c-.22,.12-.55,.29-.95,.48-.81,.4-1.94,.91-3.22,1.42-.32,.12-.63,.26-.95,.34-.32,.08-.66,.11-.96,.03-.62-.17-.99-.7-1.06-1.16-.07-.47,.1-.84,.25-1.05,.08-.1,.15-.17,.2-.22,.05-.04,.08-.06,.09-.06,.01,.01-.1,.1-.23,.31-.12,.21-.26,.56-.19,.99,.07,.42,.43,.89,.98,1.03,.27,.07,.58,.04,.88-.04,.3-.08,.61-.21,.93-.34,1.27-.51,2.41-1,3.23-1.37,.39-.17,.71-.32,.97-.44,.23-.1,.36-.15,.36-.14Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.84,213.62s-.12,.06-.34,.13l-.94,.3c-.8,.25-1.9,.58-3.12,.94-.3,.09-.6,.19-.91,.24-.3,.05-.62,.04-.89-.07-.27-.1-.5-.32-.58-.57-.09-.25-.06-.5,0-.71,.15-.42,.45-.64,.64-.76,.2-.12,.33-.16,.33-.15,0,.01-.11,.07-.29,.21-.18,.14-.45,.36-.57,.75-.06,.19-.07,.42,.01,.63,.08,.21,.27,.39,.51,.48,.24,.09,.52,.1,.81,.05,.29-.05,.58-.15,.89-.24,1.22-.36,2.33-.67,3.13-.89,.38-.1,.69-.18,.95-.25,.23-.06,.35-.08,.36-.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.88,216.44s-.41,.06-1.06,.11c-.66,.04-1.57,.1-2.58,.14-.25,.01-.5,.02-.73,.03-.24,0-.47,.02-.7-.02-.23-.04-.44-.15-.58-.31-.14-.16-.19-.38-.15-.56,.08-.36,.34-.54,.5-.62,.17-.09,.28-.08,.28-.08,0,.01-.1,.03-.25,.13-.14,.09-.36,.28-.42,.59-.02,.15,.02,.32,.14,.45,.12,.13,.3,.22,.5,.25,.2,.04,.43,.02,.67,.01,.24-.01,.48-.02,.73-.03,1.01-.05,1.92-.08,2.58-.09,.66-.01,1.07-.01,1.07,.01Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.1,214.04s-.77-.36-1.8-.47c-1.03-.12-1.85,.12-1.86,.07-.02-.03,.81-.36,1.88-.24,1.07,.11,1.81,.6,1.78,.63Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.91,262.63l1.55-.41s.55-2.61,1.23-3.16,7.56-3.68,9.07-4.5c1.51-.82,7.41-3.51,8.15-2.08,.84,1.62-1.56,2.95-2.87,3.56-1.3,.62-5.02,2.06-4.27,2.95s9.06,.49,9.06,.49l1.04-1.4s1.83,1.73,1.62,3.24c-.21,1.51-.82,2.47-.82,2.47h-.62s.62,.89,.07,1.78-1.65,2.06-1.65,2.06c0,0-.97,2.05-3.91,2.86-.34,.09-14.07,1.29-14.07,1.29l-4.59,.46,.99-9.62Z",
    style: {
      fill: "#ffbe9d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "shield",
    "data-motion": "float",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.84,58.7l-36.42-13.41-36.06,13.23c-4.6,2.23-8.64,3.57-8.64,7.97v21.9c0,15.21,3.89,30.28,11.88,43.59,6.73,11.2,17.14,22.73,33.18,30.06,14.74-4.91,25.74-18,32.47-29.2,7.99-13.31,11.88-28.38,11.88-43.59v-19.7c0-6.27-3.24-9.34-8.29-10.85Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.84,58.7l-36.42-13.41-36.06,13.23c-4.6,2.23-8.64,3.57-8.64,7.97v21.9c0,15.21,3.89,30.28,11.88,43.59,6.73,11.2,17.14,22.73,33.18,30.06,14.74-4.91,25.74-18,32.47-29.2,7.99-13.31,11.88-28.38,11.88-43.59v-19.7c0-6.27-3.24-9.34-8.29-10.85Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,67.59l-29.22-10.76-28.93,10.62c-3.69,1.79-6.93,2.86-6.93,6.39v17.57c0,12.2,3.12,24.3,9.53,34.97,5.4,8.98,13.75,18.24,26.62,24.12,11.83-3.94,20.66-14.45,26.05-23.43,6.41-10.68,9.53-22.77,9.53-34.97v-15.8c0-5.03-2.6-7.49-6.65-8.7Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.54 97.79 105.36 97.79 105.36 80.6 95.49 80.6 95.49 97.79 78.3 97.79 78.3 107.66 95.49 107.66 95.49 124.84 105.36 124.84 105.36 107.66 122.54 107.66 122.54 97.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.65,147.85s.17-.24,.51-.68l.29-.38c.1-.15,.18-.32,.29-.5,.21-.36,.46-.77,.65-1.29,.1-.25,.22-.52,.32-.81,.08-.3,.17-.61,.26-.93,.1-.32,.16-.67,.22-1.04,.05-.37,.15-.74,.16-1.14,.17-1.6,.07-3.46-.25-5.52-.64-4.13-2.39-8.99-5.07-14.27-2.67-5.29-6.36-10.99-10.88-16.92-4.53-5.94-9.97-12.07-16.22-18.22-6.26-6.15-13.35-12.33-21.3-18.18-3.98-2.92-8.17-5.76-12.59-8.43-4.42-2.68-9.07-5.17-13.99-7.33-4.91-2.14-10.09-4-15.56-4.88-2.72-.42-5.53-.62-8.3-.2-1.38,.21-2.73,.59-4.01,1.16-1.26,.61-2.41,1.43-3.36,2.46-.92,1.07-1.6,2.3-2.07,3.62-.42,1.33-.65,2.72-.7,4.12-.11,2.79,.42,5.56,1.14,8.22,1.5,5.33,3.94,10.27,6.62,14.91,2.71,4.63,5.72,8.98,8.88,13.06,3.16,4.09,6.45,7.93,9.81,11.55,6.72,7.23,13.67,13.57,20.49,19.09,6.83,5.51,13.54,10.22,19.95,14.04,6.41,3.82,12.49,6.83,18.05,8.88,5.55,2.06,10.58,3.25,14.75,3.41,2.08,.08,3.94-.02,5.51-.38,.4-.06,.76-.2,1.12-.29,.36-.1,.7-.19,1.01-.33,.31-.13,.61-.25,.9-.36,.27-.13,.52-.28,.77-.41,.49-.24,.87-.54,1.21-.79,.17-.12,.33-.23,.46-.34,.13-.12,.24-.23,.34-.33,.41-.39,.62-.58,.62-.58,0,0-.2,.21-.6,.61-.1,.1-.21,.21-.34,.33-.13,.12-.29,.22-.46,.35-.33,.25-.71,.56-1.21,.81-.24,.13-.49,.28-.77,.42-.29,.12-.58,.24-.9,.37-.31,.14-.65,.24-1.01,.34-.36,.09-.72,.24-1.12,.3-1.57,.36-3.45,.48-5.53,.41-4.19-.14-9.24-1.32-14.81-3.36-5.58-2.04-11.67-5.04-18.1-8.86-6.43-3.81-13.16-8.52-20-14.03-6.84-5.52-13.8-11.86-20.54-19.1-3.36-3.62-6.67-7.47-9.83-11.57-3.17-4.09-6.19-8.44-8.91-13.09-2.69-4.65-5.14-9.61-6.65-14.98-.73-2.68-1.26-5.48-1.16-8.32,.05-1.42,.28-2.84,.72-4.21,.48-1.35,1.19-2.63,2.13-3.73,.99-1.07,2.18-1.91,3.47-2.54,1.31-.59,2.7-.97,4.1-1.19,2.81-.43,5.65-.22,8.4,.21,5.51,.89,10.71,2.76,15.64,4.91,4.93,2.17,9.59,4.67,14.02,7.36,4.43,2.68,8.63,5.52,12.61,8.45,7.96,5.87,15.05,12.06,21.31,18.23,6.26,6.17,11.7,12.32,16.22,18.28,4.52,5.95,8.19,11.66,10.86,16.98,2.67,5.3,4.41,10.18,5.03,14.33,.31,2.07,.41,3.94,.22,5.55-.01,.4-.12,.78-.17,1.15-.06,.37-.12,.72-.22,1.04-.09,.33-.18,.64-.27,.94-.11,.29-.23,.56-.33,.81-.19,.52-.45,.93-.66,1.29-.11,.18-.2,.35-.3,.49l-.29,.37c-.35,.44-.54,.66-.54,.66Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.78,99.25s-.03-.29-.08-.85c-.01-.14-.02-.3-.04-.47-.02-.17-.07-.36-.12-.56-.09-.41-.17-.89-.38-1.39-.09-.26-.18-.54-.3-.82-.14-.27-.28-.56-.43-.87-.14-.31-.33-.61-.53-.92-.21-.31-.38-.65-.64-.96-.93-1.31-2.25-2.63-3.86-3.95-3.22-2.65-7.76-5.12-13.28-7.27-5.52-2.17-12.06-3.97-19.38-5.38-7.33-1.42-15.47-2.37-24.24-2.8-8.77-.42-18.17-.31-28,.61-4.91,.47-9.93,1.14-15,2.09-5.08,.94-10.21,2.18-15.32,3.84-5.09,1.68-10.19,3.74-14.86,6.72-2.31,1.5-4.54,3.22-6.33,5.37-.89,1.08-1.65,2.26-2.22,3.53-.53,1.29-.85,2.67-.87,4.08,.02,1.41,.34,2.78,.87,4.08,.57,1.28,1.33,2.46,2.22,3.54,1.78,2.16,4.02,3.87,6.33,5.38,4.67,2.98,9.77,5.04,14.86,6.72,5.11,1.66,10.24,2.9,15.32,3.84,5.08,.95,10.09,1.63,15.01,2.09,9.83,.92,19.23,1.03,28,.61,8.77-.43,16.91-1.38,24.24-2.8,7.33-1.42,13.86-3.21,19.38-5.38,5.51-2.16,10.05-4.62,13.28-7.27,1.61-1.32,2.93-2.64,3.86-3.95,.26-.31,.43-.65,.64-.96,.2-.31,.39-.61,.53-.92,.15-.3,.29-.59,.43-.87,.12-.28,.2-.56,.3-.82,.21-.51,.29-.99,.38-1.39,.04-.2,.09-.39,.11-.56,.01-.17,.03-.33,.04-.47,.04-.56,.08-.85,.08-.85,0,0,0,.29-.04,.85l-.03,.47c-.02,.17-.07,.36-.11,.57-.08,.41-.16,.89-.36,1.41-.09,.26-.18,.54-.29,.83-.13,.28-.28,.57-.42,.88-.14,.31-.33,.61-.53,.93-.21,.31-.38,.66-.64,.97-.93,1.32-2.25,2.65-3.86,3.99-3.22,2.68-7.77,5.17-13.29,7.35-5.53,2.19-12.07,4.01-19.4,5.44-7.34,1.43-15.49,2.4-24.27,2.84-8.78,.43-18.2,.33-28.04-.58-4.92-.46-9.95-1.14-15.04-2.09-5.09-.94-10.24-2.18-15.36-3.84-5.11-1.68-10.23-3.75-14.94-6.75-2.33-1.51-4.59-3.25-6.4-5.44-.91-1.09-1.68-2.31-2.27-3.62-.54-1.33-.87-2.75-.89-4.21,.03-1.45,.35-2.88,.9-4.2,.59-1.31,1.36-2.52,2.27-3.61,1.82-2.19,4.07-3.92,6.4-5.44,4.7-3,9.83-5.07,14.94-6.75,5.12-1.66,10.27-2.9,15.36-3.84,5.09-.95,10.11-1.62,15.03-2.09,9.84-.91,19.26-1.01,28.04-.58,8.78,.44,16.93,1.41,24.27,2.84,7.34,1.43,13.88,3.25,19.41,5.44,5.52,2.18,10.07,4.66,13.29,7.35,1.61,1.34,2.93,2.67,3.86,3.99,.26,.31,.43,.66,.64,.97,.2,.31,.39,.61,.53,.93,.15,.31,.29,.6,.42,.88,.11,.29,.2,.57,.29,.83,.2,.51,.28,1,.36,1.41,.04,.21,.09,.39,.11,.57l.03,.47c.03,.56,.04,.85,.04,.85Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,38.76s-.25-.15-.72-.46l-.4-.26c-.15-.09-.33-.16-.52-.25-.38-.18-.8-.41-1.33-.56-.26-.08-.53-.18-.83-.27-.3-.06-.62-.12-.95-.19-.33-.08-.68-.11-1.05-.14-.37-.02-.75-.1-1.15-.08-1.6-.06-3.46,.17-5.49,.63-4.07,.92-8.8,3-13.88,6.04-5.1,3.03-10.52,7.1-16.13,12.02-5.61,4.92-11.35,10.78-17.06,17.44-5.7,6.67-11.38,14.17-16.67,22.5-2.64,4.17-5.18,8.55-7.54,13.14-2.37,4.59-4.53,9.41-6.35,14.46-1.79,5.05-3.29,10.35-3.79,15.86-.23,2.75-.24,5.56,.37,8.29,.31,1.36,.77,2.69,1.43,3.92,.7,1.21,1.59,2.31,2.69,3.19,1.13,.84,2.41,1.44,3.75,1.81,1.36,.33,2.76,.46,4.15,.41,2.79-.09,5.52-.8,8.13-1.71,5.22-1.86,9.98-4.63,14.42-7.63,4.44-3.02,8.56-6.32,12.42-9.76,3.86-3.43,7.47-6.98,10.85-10.58,6.75-7.2,12.6-14.57,17.64-21.76,5.03-7.19,9.27-14.21,12.64-20.87,3.37-6.66,5.95-12.93,7.62-18.62,1.67-5.68,2.51-10.78,2.38-14.95-.06-2.08-.3-3.93-.76-5.47-.08-.39-.25-.74-.36-1.1-.12-.35-.24-.68-.4-.98-.15-.3-.29-.59-.42-.87-.15-.26-.32-.5-.46-.74-.27-.48-.6-.83-.87-1.15-.14-.16-.25-.31-.37-.44-.13-.12-.25-.22-.35-.32-.42-.38-.62-.58-.62-.58,0,0,.22,.18,.65,.56,.11,.09,.23,.2,.36,.31,.12,.12,.24,.28,.38,.43,.27,.32,.61,.67,.89,1.15,.15,.23,.32,.47,.47,.74,.14,.28,.28,.57,.43,.87,.16,.3,.29,.63,.41,.99,.12,.35,.29,.71,.37,1.1,.47,1.54,.72,3.4,.79,5.49,.14,4.19-.68,9.31-2.34,15-1.65,5.71-4.23,11.99-7.59,18.67-3.36,6.68-7.59,13.71-12.62,20.92-5.04,7.2-10.88,14.58-17.64,21.81-3.38,3.61-6.99,7.17-10.86,10.61-3.86,3.45-8,6.76-12.45,9.79-4.46,3.01-9.23,5.79-14.49,7.67-2.62,.92-5.38,1.64-8.22,1.73-1.42,.04-2.85-.09-4.25-.43-1.38-.39-2.71-1-3.87-1.87-1.13-.91-2.06-2.04-2.77-3.29-.68-1.27-1.16-2.62-1.47-4.01-.62-2.78-.61-5.62-.37-8.39,.51-5.56,2.02-10.88,3.82-15.94,1.83-5.06,4-9.89,6.38-14.49,2.37-4.6,4.91-8.99,7.56-13.16,5.31-8.34,11-15.84,16.72-22.52,5.73-6.67,11.49-12.52,17.12-17.44,5.63-4.92,11.07-8.98,16.19-12,5.1-3.03,9.85-5.1,13.95-6,2.04-.45,3.9-.68,5.52-.61,.4-.01,.79,.06,1.16,.09,.37,.03,.73,.07,1.06,.15,.33,.07,.65,.14,.95,.2,.3,.09,.57,.19,.83,.28,.53,.15,.96,.39,1.34,.57,.19,.1,.36,.17,.51,.26l.39,.27c.47,.32,.7,.49,.7,.49Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.96,129.39c1.06,1.06,1.06,2.78,0,3.83s-2.78,1.06-3.83,0c-1.06-1.06-1.06-2.78,0-3.83,1.06-1.06,2.78-1.06,3.83,0Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.95,45.36c0,1.5-1.21,2.71-2.71,2.71s-2.71-1.21-2.71-2.71,1.21-2.71,2.71-2.71,2.71,1.21,2.71,2.71Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.08,138.3c0,.38-.31,.69-.69,.69s-.69-.31-.69-.69,.31-.69,.69-.69,.69,.31,.69,.69Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.79,62.32c0,.38-.31,.69-.69,.69s-.69-.31-.69-.69,.31-.69,.69-.69,.69,.31,.69,.69Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,99.25c0,.38-.31,.69-.69,.69s-.69-.31-.69-.69,.31-.69,.69-.69,.69,.31,.69,.69Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,67.12c0,.38-.31,.69-.69,.69s-.69-.31-.69-.69,.31-.69,.69-.69,.69,.31,.69,.69Z",
    style: {
      fill: "#0A6EBD"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/membership.a76568a8efafcdf7ebc11182939c87b0.svg";
export { ForwardRef as ReactComponent };